import { Center, Spinner } from '@masterplandev/ui'

export function LoadingIndicator({
  size = 'sm',
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full-screen'
}) {
  return (
    <Center h={size === 'full-screen' ? '100dvh' : size} w="full">
      <Spinner size="xl" />
    </Center>
  )
}
